import {
  TechDocChecklistPage,
  TechDocWizardPage,
  TechDocPage,
} from '../containers/pages';
import { ALLETRAMP_VIDEO_URL } from '../constants';
import { SelectModelPage } from '../containers/selectModelPage';
const gettingStartedPath = '/getting-started/';
const cloudEnablementPath = `${gettingStartedPath}cloud-enablement/`;
export const gettingStarted = () => {
  let config = [];
  config = gettingStartedConfig();
  return config;
};
function gettingStartedConfig() {
  const menuItemArray = [
    {
      path: '/getting-started',
      menuText: 'gettingStarted',
      exact: true,
      redirectTo: '/getting-started/select-model',
      submenuItems: [
        {
          path: '/getting-started/select-model',
          menuText: 'selectStorageTier',
          pageName: 'selectStorageTier',
          exact: true,
          component: SelectModelPage,
          pageProps: {},
        },
        {
          path: cloudEnablementPath,
          menuText: 'cloudenablement',
          exact: true,
          redirectTo: `${cloudEnablementPath}1`,
        },
        {
          path: `${cloudEnablementPath}:step`,
          exact: true,
          component: TechDocWizardPage,
          pageName: 'cloudenablement',
          pageProps: {
            steps: [
              {
                videoUrl: '',
                steptitle: 'Getting Started',
              },
              {
                videoUrl: '',
                steptitle: 'Create User Account',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.CLOUD_ENABLE_STEP3,
                steptitle: 'Create Workspace',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.CLOUD_ENABLE_STEP4,
                steptitle: 'Deploy Data Services Cloud Console',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.CLOUD_ENABLE_STEP5,
                steptitle: 'Assign Administrator',
              },
            ],
          },
        },
        {
          path: '/getting-started/checklist',
          menuText: 'preInstallationVMware',
          exact: true,
          component: TechDocChecklistPage,
          pageProps: {},
        },
      ],
    },
    {
      path: '/physical-install',
      menuText: 'physicalInstallation',
      exact: true,
      redirectTo: '/physical-install/unbox',
      submenuItems: [
        {
          path: '/physical-install/unbox',
          menuText: 'unboxFactory',
          exact: true,
          redirectTo: '/physical-install/unbox/1',
        },
        {
          path: '/physical-install/unbox/:step',
          exact: true,
          component: TechDocWizardPage,
          pageName: 'unboxFactory',
          pageProps: {
            steps: [
              {
                videoUrl: ALLETRAMP_VIDEO_URL.FACTORY_UNBOX_STEP1,
                steptitle: 'Unbox Array',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.FACTORY_UNBOX_STEP2,
                steptitle: 'Remove Array From Pallet',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.FACTORY_UNBOX_STEP3,
                steptitle: 'Stabilize the Rack',
              },
            ],
          },
        },
        {
          path: '/physical-install/cable',
          menuText: 'cable',
          exact: true,
          redirectTo: '/physical-install/cable/1',
        },
        {
          path: '/physical-install/cable/:step',
          exact: true,
          component: TechDocWizardPage,
          pageName: 'cable',
          pageProps: {
            steps: [
              {
                videoUrl: ALLETRAMP_VIDEO_URL.FIELD_CABLE_STEP1,
                steptitle: 'Cable Admin Ports',
              },
              {
                steptitle: 'Cable CDMs',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.FIELD_CABLE_SWITCHED_STEP2,
                steptitle: 'Cable Data Ports',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.FIELD_CABLE_STEP3,
                steptitle: 'Cable Hosts',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.FIELD_CABLE_STEP4,
                steptitle: 'Cable Power Supplies',
              },
            ],
          },
        },
        {
          path: '/physical-install/powerOn',
          menuText: 'powerOn',
          exact: true,
          component: TechDocPage,
          pageProps: {
            videoUrl: ALLETRAMP_VIDEO_URL.POWERUPANDINIT,
          },
        },
      ],
    },
    {
      path: '/software-config',
      menuText: 'softwareConfig',
      exact: true,
      redirectTo: '/software-config/reimageEsxiServer',
      submenuItems: [
        {
          path: '/software-config/reimageEsxiServer',
          menuText: 'reimageEsxiServer',
          exact: true,
          component: TechDocPage,
          pageProps: {},
        },
        {
          path: '/software-config/connectDSCVM',
          menuText: 'connectDSCVM',
          exact: true,
          component: TechDocPage,
          pageProps: {},
        },
        {
          path: '/software-config/connectDSCandArray',
          menuText: 'connectDSCandArray',
          exact: true,
          component: TechDocPage,
          pageProps: {},
        },
        {
          path: '/software-config/activateDSC',
          menuText: 'activateDSC',
          exact: true,
          component: TechDocPage,
          pageProps: {},
        },
        {
          path: '/software-config/setupPCBE',
          menuText: 'setupPCBE',
          exact: true,
          component: TechDocPage,
          pageProps: {},
        },
      ],
    },
  ];
  return menuItemArray;
}
